import React from 'react';

export const AnalyticsSkeleton: React.FC = () => {
  return (
    <div className="mt-5">
      <main className="w-full flex flex-col gap-y-3 px-3">
        <style>{`
          @keyframes shimmer {
            0%   { background-position: -700px 0; }
            100% { background-position:  700px 0; }
          }

          .sk {
            background: linear-gradient(90deg, #e2ddf8 25%, #cfc8f0 50%, #e2ddf8 75%);
            background-size: 700px 100%;
            animation: shimmer 1.5s infinite linear;
            border-radius: 6px;
            display: block;
          }

          .sk-icon {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            flex-shrink: 0;
          }

          .sk-icon.selected {
            box-shadow: 0 0 0 3px #fff, 0 0 0 5px #c4b5fd;
          }

          .icons-row {
            display: flex;
            gap: 12px;
            align-items: center;
          }

          .refresh-bar {
            background: #fff;
            border: 1px solid #ece8fb;
            border-radius: 10px;
            padding: 12px 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .sk-refresh-text {
            height: 13px;
            width: 240px;
          }

          .sk-refresh-icon {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            flex-shrink: 0;
          }

          .main-row {
            display: grid;
            grid-template-columns: 1fr 320px;
            gap: 14px;
            align-items: flex-start;
          }

          .left-panel {
            background: #fff;
            border: 1px solid #ece8fb;
            border-radius: 14px;
            padding: 24px 22px;
            display: flex;
            flex-direction: column;
            gap: 14px;
            min-height: 280px;
          }

          .sk-page-name {
            height: 26px;
            width: 200px;
          }

          .sk-page-sub {
            height: 13px;
            width: 160px;
          }

          .stats-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 12px;
            margin-top: 4px;
          }

          .stat-box {
            border: 1px solid #ece8fb;
            border-radius: 10px;
            padding: 16px 12px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
          }

          .sk-stat-num {
            height: 22px;
            width: 36px;
          }

          .sk-stat-label {
            height: 12px;
            width: 52px;
          }

          .right-panel {
            background: #fff;
            border: 1px solid #ece8fb;
            border-radius: 14px;
            padding: 18px 16px;
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .right-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 2px;
          }

          .sk-rp-title {
            height: 16px;
            width: 110px;
          }

          .sk-rp-count {
            height: 13px;
            width: 44px;
          }

          .post-item {
            border: 1px solid #ece8fb;
            border-radius: 10px;
            padding: 12px 14px;
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .sk-post-line1 {
            height: 13px;
            width: 100%;
          }

          .sk-post-line2 {
            height: 13px;
            width: 80%;
          }

          .sk-post-meta {
            display: flex;
            gap: 14px;
            margin-top: 2px;
          }

          .sk-meta-item {
            height: 11px;
            width: 60px;
          }

          @media (max-width: 768px) {
            .main-row {
              grid-template-columns: 1fr;
            }
          }
        `}</style>

        <div>
          <h1 className="text-3xl font-bold text-gray-900">
              Analytics
            </h1>
        </div>

        {/* Platform icons */}
        <div className="icons-row">
          <div className="sk sk-icon selected"></div>
          <div className="sk sk-icon"></div>
          <div className="sk sk-icon"></div>
          <div className="sk sk-icon"></div>
          <div className="sk sk-icon"></div>
        </div>

        {/* Refresh bar */}
        <div className="refresh-bar">
          <div className="sk sk-refresh-text"></div>
          <div className="sk sk-refresh-icon"></div>
        </div>

        {/* Main layout */}
        <div className="main-row">
          {/* Left panel */}
          <div className="left-panel">
            <div className="sk sk-page-name"></div>
            <div className="sk sk-page-sub"></div>

            <div className="stats-grid">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="stat-box">
                  <div className="sk sk-stat-num"></div>
                  <div className="sk sk-stat-label"></div>
                </div>
              ))}
            </div>
          </div>

          {/* Right panel */}
          <div className="right-panel">
            <div className="right-header">
              <div className="sk sk-rp-title"></div>
              <div className="sk sk-rp-count"></div>
            </div>

            {[...Array(4)].map((_, i) => (
              <div key={i} className="post-item">
                <div className="sk sk-post-line1"></div>
                <div className="sk sk-post-line2" style={{ width: `${75 + i * 5}%` }}></div>
                <div className="sk-post-meta">
                  <div className="sk sk-meta-item"></div>
                  <div className="sk sk-meta-item"></div>
                  <div className="sk sk-meta-item" style={{ width: '44px' }}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};
